import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Sex from './sex';
import SexDetail from './sex-detail';
import SexUpdate from './sex-update';
import SexDeleteDialog from './sex-delete-dialog';

const SexRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Sex />} />
    <Route path="new" element={<SexUpdate />} />
    <Route path=":id">
      <Route index element={<SexDetail />} />
      <Route path="edit" element={<SexUpdate />} />
      <Route path="delete" element={<SexDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default SexRoutes;
